import {
  FormHelperText,
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { EChargeType } from 'interfaces/IEditProduct';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormContent } from 'scenes/Producer/Product/EditProduct/components/FormContent';
import { run } from 'validations/ruleRunner';

import type { User } from 'v2/interfaces/user';

import Validations from './validations';
import styles from '../styles';

import type IProduct from 'interfaces/IProduct';
import type { DispatchProp } from 'react-redux';

interface IProps extends IPropsFromConnect, DispatchProp<any>, StyledComponentProps {
  product: IProduct;
  handleChange?: any;
  classes?: any;
  enabledValidation?: boolean;
}

interface IPropsFromConnect {
  currentUser: User;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
  showAlertUncheck: boolean;
}

class SalesRecovery extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: [],
      showAlertUncheck: false,
    };
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  handleToggleAlertVisibility = () => {
    const newState = { ...this.state };
    newState.showAlertUncheck = !newState.showAlertUncheck;
    this.setState(newState);
  };

  handleUncheckConfirmed = (currentProduct: IProduct) => {
    const { handleChange } = this.props;

    currentProduct.recovery_email = '';
    handleChange('recovery_email', '');
    handleChange('sales_recovery', false);

    this.handleToggleAlertVisibility();
  };

  onChangeRequired = (name: string, fields: any) => {
    let newState = this.state;
    newState[name] = fields;
    this.setState(newState);
  };

  componentDidMount(): void {
    if (!this.props.product.recovery_email) {
      this.props.handleChange(
        'recovery_email',
        this.props.product.recovery_email || this.props.currentUser.business_name || this.props.currentUser.full_name
      );
    }
  }

  componentDidUpdate(prevProps: IProps) {
    const { product, handleChange, enabledValidation } = this.props;

    const hasChangedProduct = product !== prevProps.product;

    if (hasChangedProduct) {
      const isOpenValue = product.charge_type === EChargeType.OTHER;

      if (isOpenValue && product.sales_recovery) {
        handleChange('sales_recovery', false);
      }
    }

    const hasEnabledValidation = !prevProps.enabledValidation && enabledValidation;
    const hasChangedProductWithValidation = enabledValidation && hasChangedProduct;

    if (hasEnabledValidation || hasChangedProductWithValidation) {
      this.setState({ validationErrors: { ...run(product, Validations) } });
    }
  }

  render() {
    const { handleChange, product, classes } = this.props;

    const isOpenValue = product.charge_type === EChargeType.OTHER;

    const { showAlertUncheck } = this.state;

    return (
      <FormContent title='Recuperação de vendas'>
        <Grid container spacing={2} alignItems='center'>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={12}>
                <Tooltip title={isOpenValue ? '*Não é possível ativar a recuperação com Valor Aberto' : ''} placement='right'>
                  <FormControlLabel
                    label='Recuperar vendas perdidas'
                    id={'sales_recovery'}
                    disabled={isOpenValue}
                    control={
                      <Switch
                        color='primary'
                        checked={product.sales_recovery}
                        onChange={(e) => {
                          const willCheck = e.target.checked;

                          if (willCheck) {
                            return handleChange('sales_recovery', willCheck);
                          }

                          return this.setState({ showAlertUncheck: true });
                        }}
                      />
                    }
                  />
                </Tooltip>
                <FormHelperText>
                  A Eduzz tentará recuperar vendas não concretizadas.{' '}
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807625289-Como-funciona-a-recupera%C3%A7%C3%A3o-de-vendas-perdidas-RVP-'
                  >
                    Saiba Mais
                  </a>
                </FormHelperText>
              </Grid>

              {product.sales_recovery && (
                <Grid item xs={12}>
                  <Tooltip title={'O nome definido neste campo aparecerá como remetente nos e-mails enviados de Recuperação de Vendas.'}>
                    <TextField
                      className={classes.input}
                      label='Nome do remetente de e-mail para recuperação de vendas'
                      id='recovery_email'
                      helperText={this.isValid('recovery_email') ? this.errorFor('recovery_email') : 'Ex: Fulano da Silva - Eduzz'}
                      error={this.isValid('recovery_email')}
                      fullWidth
                      value={product.recovery_email}
                      onChange={(e: any) => handleChange('recovery_email', e.target.value)}
                      disabled={!product.sales_recovery}
                      InputProps={{
                        disableUnderline: true,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Tooltip>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Dialog
          open={showAlertUncheck}
          onClose={this.handleToggleAlertVisibility}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>Tem certeza que deseja desativar esta funcionalidade?</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              Mantenha a RVP ativa para recuperar até 10% das suas vendas e aumentar suas conversões com clientes que abandonam o carrinho de forma
              automática.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleUncheckConfirmed(product)}>Desativar mesmo assim</Button>
            <Button onClick={this.handleToggleAlertVisibility} variant='contained' color='primary' autoFocus>
              Manter ativado
            </Button>
          </DialogActions>
        </Dialog>
      </FormContent>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    currentUser: state.orbita.User.user.user,
  };
}

export default connect(mapStateToProps)(styles(SalesRecovery));
